export enum EventTypes {
  click = 'click',
  keyDown = 'keydown',
  change = 'change',
}
